import { dataGather } from "@/utils/aLiLogTracking.js"

export function hsjH5BurialPoint(page='', event='', properties = '') {
    //因为dataGather是后面才添加上的阿里云埋点，之前的埋点全部使用hsjH5BurialPoint方法，避免更多的修改直接对接。以后埋点请不要在使用此方法
    //应该直接导入dataGather进行埋点
    dataGather(page,event,properties)
}
export function activityH5BurialPoint(activityId,page = "", event = "", properties = "") {
    //因为activityH5BurialPoint是后面才添加上的阿里云埋点，之前的埋点全部使用hsjH5BurialPoint方法，避免更多的修改直接对接。以后埋点请不要在使用此方法
    //应该直接导入dataGather进行埋点
    dataGather(page,event,properties)
}
